import React, { useRef, useState, useEffect } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { requisitos } from '../datos/requisitos';

// Importar imágenes para el PDF
import encabezadoImg from './informes/encabezado_A4.png';
import pieImg from './informes/pie_hoja_A4.png';


const PreviewAndDownloadPDFReport = ({ data }) => {
	console.log("data en previewAndDownloadPDFReport", data)
	// 1. Todos los Hooks primero
	const pdfRef = useRef(null);

	const [isLoading, setIsLoading] = useState(true);
	const [documentosSeleccionados, setDocumentosSeleccionados] = useState([]);
	const [areaResponsable, setAreaResponsable] = useState();
	const [tipoSubsidio, setTipoSubsidio] = useState();
	//const [requisitosHabilitados, setRequisitosHabilitados] = useState([]);
	const [labelsSeleccionados, setLabelsSeleccionados] = useState([]);
	const [labelsNoSeleccionados, setLabelsNoSeleccionados] = useState([]);
	const [arrayLabelsSeleccionados, setArrayLabelsSeleccionados] = useState([]);
	const [arrayLabelsNoSeleccionados, setArrayLabelsNoSeleccionados] = useState([]);
	const [observacionesReporte, setObservacionesReporte] = useState('');

	// Estado para manejar los datos de la obra
	const [obraData, setObraData] = useState(null);
	console.log("OBRA DATA", obraData)

	// Función para obtener los datos del formulario B
	const getFormB_Tramitacion = async (idPartidoObra) => {
		if (!idPartidoObra) return;

		const urlFormB = `/api/form_b_tramitacion/${idPartidoObra}`;
		const headers = { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' };

		try {
			const response = await fetch(urlFormB, { headers });

			if (!response.ok) {
				if (response.status === 404) {
					console.log("Formulario no encontrado");
				} else {
					throw new Error(`Error HTTP! status: ${response.status}`);
				}
				return;
			}

			const data = await response.json();
			setDocumentosSeleccionados(data.documentos_seleccionados || []);
			setObservacionesReporte(data.observaciones_reporte || '');

		} catch (error) {
			console.error('Error al buscar formulario por ID:', error);
			setDocumentosSeleccionados([]);
		} finally {
			setIsLoading(false);
		}
	};

	// 2. Un único useEffect para manejar la carga inicial y cambios
	useEffect(() => {
		// Si data existe, actualizamos el estado local
		if (data) {
			console.log("ACTUALIZAR")
			setObraData(data);
			setAreaResponsable(data.area_responsable);
			setTipoSubsidio(data.tipo_subsidio);

			// Si tiene id, llamamos a la función para obtener el formulario B
			if (data.id_partido_obra) {
				getFormB_Tramitacion(data.id_partido_obra);
			} else {
				// Si no tiene id, terminamos la carga
				setIsLoading(false);
			}
		} else {
			// Si no hay data, terminamos la carga y el componente mostrará el mensaje de error
			setIsLoading(false);
		}
	}, [data]); // Dependencia del useEffect

	// Efecto para calcular los requisitos habilitados cuando cambian documentosSeleccionados, areaResponsable o tipoSubsidio
	useEffect(() => {
		// Si no hay documentos seleccionados, no hacemos nada.
		if (Object.keys(documentosSeleccionados).length === 0) {
			setArrayLabelsSeleccionados([]);
			setArrayLabelsNoSeleccionados([]);
			setLabelsSeleccionados([]);
			setLabelsNoSeleccionados([]);
			return;
		}

		const nuevosPresentados = [];
		const nuevosSinPresentar = [];
		let labelsPresentados = [];
		let labelsNoPresentados = [];
		let currentSection = '';

		requisitos.forEach(req => {
			// Verifica si el requisito está habilitado
			// Pasa las variables de estado como argumentos a isEnabled()
			const isEnabled = req.isSectionHeader
				? req.isEnabled(areaResponsable, tipoSubsidio)
				: req.isEnabled(areaResponsable, tipoSubsidio) && documentosSeleccionados.hasOwnProperty(req.id);

			if (isEnabled) {
				const item = {
					id: req.id,
					label: req.label,
					isSectionHeader: req.isSectionHeader || false,
					section: currentSection
				};

				if (req.isSectionHeader) {
					// Los encabezados van a ambas listas
					currentSection = req.label;
					nuevosPresentados.push(item);
					nuevosSinPresentar.push(item);
				} else {
					// Se separan según el estado de selección
					const isSelected = documentosSeleccionados[req.id] === true;
					if (isSelected) {
						nuevosPresentados.push({ ...item, presentado: true });
						labelsPresentados.push(item.label);
					} else {
						nuevosSinPresentar.push({ ...item, presentado: false });
						labelsNoPresentados.push(item.label);
					}
				}
			}
		});

		// Actualiza los estados de una sola vez
		setArrayLabelsSeleccionados(nuevosPresentados);
		setArrayLabelsNoSeleccionados(nuevosSinPresentar);
		setLabelsSeleccionados(labelsPresentados);
		setLabelsNoSeleccionados(labelsNoPresentados);

	}, [documentosSeleccionados, areaResponsable, tipoSubsidio]);

	// 3. Si no hay datos, mostramos un mensaje
	if (isLoading) {
		return (
			<div className="flex items-center justify-center h-screen">
				<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
			</div>
		);
	}

	if (!data || !obraData) {
		return (
			<div className="p-4 text-center text-red-600">
				No hay datos para generar el informe.
			</div>
		);
	}

	// 4. Destructuring de obraData (que sabemos que no es null aquí)
	const {
		nombre_obra,
		id_partido_obra,
		tipo_subsidio,
		area_responsable,
		//array_obras_expediente, //add 6-oct-2025
		partido_nombre,
		lc_21_localidad,//no es ---> localidad
		//barrio,
		barrio_rppvap_nombre,
		barrio_otro_nombre,
		organismo_solicitante,
		organismo_otro,
		programa_lineamiento,
		modalidad,
		monto_obra,
		tipo_contratacion,
		plazo_obra,
		beneficiarios,
		lc_22_identificacion_catastral,
		lc_22_1_datos_catastrales,
		lc_22_2_cuadro_calles,
		lc_24_titular_dominio,
		descripcion_proyecto,
		//array_tipo_subtipo_proyecto,
		documentos,
		requisitosHabilitados,
		//observaciones_reporte,
		//labelsSeleccionados,
		//labelsNoSeleccionados,
		//arrayLabelsSeleccionados,
		//arrayLabelsNoSeleccionados,
		reportData
	} = obraData.datosGenerales;
	console.log("en obraData", obraData)

	const array_obras_expediente = obraData?.array_obras_expediente || [];

	const array_tipo_subtipo_proyecto = obraData?.tipoSubtipoProyecto || [];
	//NOTA IMPORTANTE:
	//si es un array no hacer destructuring {array_tipo_subtipo_proyecto} asignar directamente:
	//const array_tipo_subtipo_proyecto = obraData?.tipoSubtipoProyecto || [];

	// 1. Usar find() para obtener el objeto "Proyecto" - add 6-oct-2025
	const objeto_proyecto = array_obras_expediente?.find(item => item.objeto_o === "Proyecto");

	// 2. Extraer el valor de expediente_o si el objeto fue encontrado - add 6-oct-2025
	let expediente_proyecto = null;
	if (objeto_proyecto) {
		expediente_proyecto = objeto_proyecto.expediente_o;
	}

	// Efecto para cargar los datos del formulario B de tramitación	

	const handleDownloadPDF = async () => {
		try {
			setIsLoading(true);
			const element = pdfRef.current;
			if (!element) return;

			// Convertir el contenido a imagen con html2canvas
			const canvas = await html2canvas(element, {
				scale: 2,
				//useCORS: true,
				//logging: true

			});

			const imgData = canvas.toDataURL('image/png');
			const pdf = new jsPDF('p', 'mm', 'a4');
			const pdfWidth = pdf.internal.pageSize.getWidth();
			const pdfHeight = pdf.internal.pageSize.getHeight();

			// Ajustar la imagen al tamaño de la página
			const imgWidth = canvas.width;
			const imgHeight = canvas.height;
			const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
			const finalWidth = imgWidth * ratio;
			const finalHeight = imgHeight * ratio;

			// Centrar horizontalmente
			const x = (pdfWidth - finalWidth) / 2;

			// Agregar la imagen al PDF
			pdf.addImage(imgData, 'PNG', x, 0, finalWidth, finalHeight);

			// Guardar el PDF con el ID de la obra
			//si existe id_partido_obra usar en el nombre y si no existe usar solo informe tecnico
			if (id_partido_obra) {
				const obraId = id_partido_obra;
				pdf.save(`informe_tecnico_${obraId}.pdf`);
			} else {
				pdf.save('informe_tecnico.pdf');
			}
		} catch (error) {
			console.error('Error al generar el PDF:', error);
		} finally {
			setIsLoading(false);
		}
	};
	/*const handleDownloadPDF = async () => {
		const element = pdfRef.current;
		if (!element) return;

		const canvas = await html2canvas(element, { scale: 2 });
		const imgData = canvas.toDataURL('image/png');

		const pdf = new jsPDF('p', 'mm', 'a4');
		const pdfWidth = pdf.internal.pageSize.getWidth();
		const pdfHeight = pdf.internal.pageSize.getHeight();

		// Asegúrate de que la imagen se ajuste a la página manteniendo la relación de aspecto
		const imgWidth = canvas.width;
		const imgHeight = canvas.height;
		const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);

		const finalWidth = imgWidth * ratio;
		const finalHeight = imgHeight * ratio;

		// Agregar la imagen con un pequeño margen
		pdf.addImage(imgData, 'PNG', 0, 0, finalWidth, finalHeight);
		pdf.save('informe_tecnico.pdf');
	};*/

	//misntras se ejecuta el fetch mostrar un mensaje de loading
	if (isLoading) {
		return (
			<div className="flex items-center justify-center h-screen">
				<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
			</div>
		);
	}

	// Mover la verificación después de los Hooks
	if (!data) {
		return (
			<div className="p-4 text-center text-red-600">
				No hay datos para generar el informe.
			</div>
		);
	}

	{/*necesito que el div que contiene todo el contenido ocupe mas ancho de pantalla	 */ }
	return (
		<div className="bg-white p-8 px-10 sm:p-12 shadow-xl rounded-lg w-full max-w-6xl mx-auto my-6 font-sans border border-gray-200">
			<button
				onClick={handleDownloadPDF}
				className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
			>
				<svg className="-ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
					<path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
				</svg>
				Descargar PDF
			</button>

			<div className="p-10" ref={pdfRef}>
				<div className="mb-6">
					<img
						src={encabezadoImg}
						alt="Encabezado del informe"
						className="w-full h-auto max-h-[250px] object-cover"
					//style={{ maxHeight: '100px', objectFit: 'contain' }}
					/>
				</div>

				<div className="text-center mb-6">
					<h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-1">
						Informe técnico
					</h1>
					<h2 className="text-lg sm:text-xl text-gray-600">
						Dirección Provincial de Intervenciones Complementarias
					</h2>
				</div>

				<div className="grid grid-cols-1 sm:grid-cols-1 gap-x-8 gap-y-4 text-sm sm:text-base text-gray-700 mb-6 border-b pb-6">
					<div>
						<p>
							<strong className="font-semibold text-gray-900">
								Nombre del Proyecto/alias:
							</strong>{' '}
							{nombre_obra}
						</p>
					</div>
					{/*en un div alineado a la derecha - add 6-oct-2025: cambiamos expediente x expediente_proyecto */}
					<div className="text-right">
						<p>
							<strong className="font-semibold text-gray-900">
								Referente al Expediente:
							</strong>{' '}
							{expediente_proyecto ? expediente_proyecto : 'No especificado'}
						</p>
					</div>
					<p>
						<strong className="font-semibold text-gray-900">Localización:</strong>{' '}
						Partido: {partido_nombre} - Localidad: {lc_21_localidad} - Barrio: {barrio_rppvap_nombre || barrio_otro_nombre}
					</p>
					<div>
						<p>
							<strong className="font-semibold text-gray-900">
								Organismo Solicitante:
							</strong>
							{' '}
							{
								tipo_subsidio === 'Subsidio a municipio'
									? `Municipio de ${partido_nombre || ''}`
									: tipo_subsidio === 'Subsidio a ONG'
										? `ONG ${organismo_solicitante || ''}`
										: organismo_otro || ''
							}
						</p>
					</div>
					<div>
						<p>
							<strong className="font-semibold text-gray-900">Programa:</strong>{' '}
							{programa_lineamiento}
						</p>
					</div>
					<div>
						<p>
							<strong className="font-semibold text-gray-900">Modalidad:</strong>{' '}
							{modalidad}
						</p>
					</div>
					<div>
						<p>
							<strong className="font-semibold text-gray-900">
								Monto de obra en $:
							</strong>{' '}
							{Number(monto_obra).toLocaleString('es-AR')}
						</p>
					</div>
					<div>
						<p>
							<strong className="font-semibold text-gray-900">
								Tipo de contratación:
							</strong>{' '}
							{tipo_contratacion}
						</p>
					</div>
					<div>
						<p>
							<strong className="font-semibold text-gray-900">
								Plazo de obra:
							</strong>{' '}
							{plazo_obra}
						</p>
					</div>
					<div>
						<p>
							<strong className="font-semibold text-gray-900">
								Beneficiarios:
							</strong>{' '}
							{beneficiarios}
						</p>
					</div>
					<div>
						<p>
							<strong className="font-semibold text-gray-900">
								**Ubicación del Proyecto**
							</strong>{' '}
							<br />

							{lc_22_identificacion_catastral === 'SI' && (
								<div>
									<p>
										<strong className="font-semibold text-gray-900">Datos catastrales: </strong>
										{' '}{lc_22_1_datos_catastrales}
									</p>
								</div>
							)}

							<br />
							<div>
								<div style={{ whiteSpace: 'pre-wrap' }}>
									<strong className="font-semibold text-gray-900">Cuadro de calles: </strong>
									{' '}{lc_22_2_cuadro_calles}
								</div>
							</div>
							<br />
							<strong className="font-semibold text-gray-900">Titular de dominio: </strong>{' '}
							{lc_24_titular_dominio}
						</p>
					</div>
				</div>

				<div className="mb-6">
					<h3 className="text-xl font-semibold text-gray-800 mb-2">
						Categorías por ítems de obra:
					</h3>
					{array_tipo_subtipo_proyecto?.length > 0 ? (
						<ul className="list-disc list-inside space-y-1 text-gray-700">
							{array_tipo_subtipo_proyecto?.map((item, index) => (
								<li key={index}>
									<strong className="font-medium">{item.tipo}:</strong>{' '}
									{item.subtipo} - {item.cantidad} - {item.unidad}
								</li>
							))}
						</ul>
					) : (
						<p className="text-gray-500 italic">No se especificaron ítems de obra.</p>
					)}
				</div>

				<div className="mb-6">
					<h3 className="text-xl font-semibold text-gray-800 mb-2">
						Descripción del proyecto:
					</h3>
					<div className="text-gray-700" style={{ whiteSpace: 'pre-wrap' }}>{descripcion_proyecto}</div>
				</div>

				<div className="border-t pt-6">
					<h3 className="text-xl font-semibold text-gray-800 mb-2">
						Evaluación y factibilidad de la propuesta
					</h3>
					<p className="text-gray-700 mb-4">
						Analizada la propuesta de la {tipo_subsidio === 'Subsidio a municipio'
							? `Municipalidad de ${partido_nombre || ''}`
							: tipo_subsidio === 'Subsidio a ONG'
								? `ONG ${organismo_solicitante || ''}`
								: organismo_otro || ''
						}, la Dirección Provincial de Intervenciones Complementarias procedió a verificar la documentación técnica presentada por la misma.
						En ese sentido, se considera que el proyecto solicitado resulta viable técnicamente y su presupuesto económicamente razonable.

					</p>
				</div>

				<div className="mt-8 text-right text-sm text-gray-500">
					<p>Fecha de salida: {new Date().toLocaleDateString('es-AR')}</p>
					<p>.</p>
				</div>

				{/* Previsualización del pie de página */}
				<div className="mb-6">
					<img
						src={pieImg}
						alt="Pie de página del informe"
						className="w-full h-auto"
					//className="w-full h-auto max-h-[250px] object-cover"
					// Si necesitas limitar la altura máxima, puedes añadir:
					// style={{ maxHeight: '250px', objectFit: 'contain' }}
					// Pero esto podría impedir que la imagen ocupe todo el ancho si es muy alta.
					/>
				</div>

			</div>
		</div>
	);

}

export default PreviewAndDownloadPDFReport;